<template>

    <v-dialog scrollable max-width="300px" v-model="showDialog">
      <template v-slot:activator="{ on }">
            <v-icon :disabled="disabled"  small v-on="on" >edit</v-icon>
      </template>
      <v-card >
        <v-card-title>
          <h4>Actualizar monto</h4>
        </v-card-title>
        <v-card-text>
            <v-form ref="form">
              <v-text-field type=text label="Monto" v-model="nuevoMonto" autofocus/>
            </v-form>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="info" @click="volver">Volver</v-btn>
          <v-btn color="info" @click="confirmar">Actualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
  props: ["id","monto","disabled"],
  data() {
    return {
      loading : false,
      showDialog: false,
      nuevoMonto: 0,
      rules: {
        required: value => !!value || "Requerido.",
        counter: value => value.length <= 1000 || "Maximo 100 caracteres"
      },
      validForm: false
    };
  },
  mounted() {
    this.nuevoMonto = this.monto;
  },
  methods: {
    close() {
      this.showDialog = false;
    },
    volver() {
      this.showDialog = false;
    },
    confirmar() {

      axios
        .patch(`/bolsa/${this.id}/actualizarMonto/${this.nuevoMonto}`)
        .then(response => {
          console.log(response);
          this.$emit('nuevoMontoBolsa', {bolsaId: this.id, nuevoMontoBolsa: +this.nuevoMonto});
          this.close();
        })
        .catch(err => {
          this.loading = false;
          this.nuevaCedula = this.cedula;
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    }
  }
});
</script>